import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../../config";
import {
  CircularProgress,
  IconButton,
  Tooltip,
} from "@mui/material";
import Pagination from "../../Pagination/Pagination";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import { Visibility, Send } from "@mui/icons-material";
import moment from "moment";
import { useAppContext } from "../../Lib/ContextLib";

const NotificationTable = ({ rowValue }) => {
  const { accessObject } = useAppContext();
  const [notificationData, setNotificationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [totalLength, setTotalLength] = useState(0);
  const [pagination, setPagination] = useState({
    start: 0,
    end: limit,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const updateShowPerpagevalue = (value) => {
    setLimit(value);
    setPage(1);
    setPagination({ start: 0, end: value });
  };

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}/api/admin/notification/get-notification-by-player`,
        {
          params: {
            page,
            limit,
            playerId: rowValue?.playerId || rowValue?._id || "",
          },
        }
      );

      if (response.data.status) {
        setNotificationData(response.data.data.data);
        const totalItems = response.data.data.totalLength;
        setTotalLength(totalItems);
        setTotalPages(Math.ceil(totalItems / limit));
      } else {
        console.error(response.data.message);
      }
    } catch (err) {
      console.error("Error fetching notifications:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (rowValue?.playerId || rowValue?._id) {
      fetchNotifications();
    } else {
      // No player ID available — stop loader immediately
      setLoading(false);
    }
  }, [rowValue, page, limit]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleResendNotification = async (notificationId) => {
    try {
      const response = await axios.post(
        `${API_URL}/api/admin/notification/resend`,
        { notificationId, playerId: rowValue._id }
      );
      if (response.data.status) {
        alert("Notification resent successfully!");
        fetchNotifications();
      }
    } catch (error) {
      console.error("Error resending notification:", error);
      alert("Failed to resend notification");
    }
  };

  return (
    <div className="content p-3">
      <div className="card">
        <div className="row pl-4 pr-4 pt-4">
          <div className="col-7">
            <h3 className="card-title">
              <b>Notification List</b>
            </h3>
          </div>
        </div>

        <div className="card-body" style={{ overflow: "scroll" }}>
          <table id="" className="table table-bordered table-striped">
        <thead>
          <tr>
            <th style={{ textAlign: "center" }}>SrNo</th>
            <th style={{ textAlign: "center" }}>Date</th>
            <th style={{ textAlign: "center" }}>Title</th>
            <th style={{ textAlign: "center" }}>Message</th>
            <th style={{ textAlign: "center" }}>Type</th>
            <th style={{ textAlign: "center" }}>Status</th>
            {/* <th style={{ textAlign: "center" }}>Actions</th> */}
          </tr>
        </thead>
        {accessObject?.getNotificationList === true ? (
          <tbody>
            {!loading && (
              <>
                {notificationData.length > 0 ? (
                  notificationData?.map((item, index) => {
                    return (
                      <tr key={index}>
                         <td style={{ textAlign: "center" }}>
                           {index + 1 + (page - 1) * limit}
                         </td>
                        <td style={{ textAlign: "center" }}>
                          {moment(item.createdAt).format(
                            "DD/MM/YYYY HH:mm"
                          )}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {item.title || "-"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {item.message || "-"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {item.type === 0 ? "Normal" : "Priority"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                           {Array.isArray(item.readUsers) && item.readUsers.includes(rowValue?.playerId) ? (
                             <span className="text-success">Read</span>
                           ) : (
                             <span className="text-danger">Unread</span>
                           )}
                         </td>
                      </tr>
                    );
                  })
                ) : (
                  <EmptyState colSpan={6} message="No Notifications Found" subMessage="No notification history found for this player." />
                )}
              </>
            )}
          </tbody>
        ) : (
          <tbody>
            <tr style={{ backgroundColor: "rgba(0,0,0,.05)" }}>
              <td colSpan={6} style={{ textAlign: "center" }}>
                <h5 className="text-center">Access Denied</h5>
              </td>
            </tr>
          </tbody>
        )}
      </table>

        </div>
        {accessObject?.getNotificationList === true && (
          <div className="mt-4" style={{ display: "flex", justifyContent: "center" }}>
            {loading && <Loader />}
          </div>
        )}
        {accessObject?.getNotificationList === true && !loading && notificationData.length > 0 && (
          <Pagination
            updateShowPerpagevalue={updateShowPerpagevalue}
            showPrePage={limit}
            onPaginationChange={onPaginationChange}
            total={totalLength}
            paginationTypeApi={true}
            pageNumber={page}
            setPageNumber={setPage}
            recordLength={limit}
            setRecordLength={setLimit}
            totalLength={totalLength}
          />
        )}
      </div>
    </div>
  );
};

export default NotificationTable;
